<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 15:42:20
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 17:06:49
-->
<template>
  <!-- 管理员账号 -->
  <v-card>
    <v-card-text class="tableBoxComponent">
      <v-data-table :headers="headers" hide-default-footer :items="desserts">
        <template v-slot:no-data>
          <mrc_ess_noContent :no_data_text="$t('label_blank')" />
        </template>
        <template v-slot:item.org_level_uuid="{ item }">
          <div class="d-flex flex-column">
            <span
              v-for="(item1, index1) in splitINT(item.org_level_uuid)"
              :key="index1"
            >
              {{ INT(item1) }}
            </span>
          </div>
        </template>

        <template v-slot:item.manager_type="{ item }">
          <span>
            {{ INT(item.manager_type) }}
          </span>
        </template>

        <template v-slot:item.actions="{ item }" v-if="!readonly">
          <menu-list :list="menulist" @handleClick="handleClick($event, item)">
            <template v-slot:showAction>
              <v-icon>mdi-dots-vertical</v-icon>
            </template>
          </menu-list>
        </template>

        <template v-slot:footer>
          <div>
            <mrc_ess_paginationsWeb
              :options="options"
              @setPerPage="setPerPage"
              @change="turnPage"
            >
            </mrc_ess_paginationsWeb>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { admin_account_reset } from "@/service/api/admin_account_manage"
import { mrc_admin_reset } from "@/service/api/mrc_system_admin"
export default {
  props: {
    list: {},
    readonly: {
      type: Boolean,
    },
  },
  data() {
    return {
      options: {},
      loading: false,
      show: false,
      desserts: [],
    }
  },
  methods: {
    handleClick({ index, item }, obj) {
      this.resetpwd(obj)
    },
    resetpwd(val) {
      this.$myConfirm({
        content: this.$t("message_Confirm_that_the_password_is_reset"),
      })
        .then(() => {
          mrc_admin_reset({
            uuid: val.uuid,
            login_url: this.$store.state.loginUrl,
          }).then((res) => {
            if (res.code == 200) {
              this.$emit("change")
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              })
            }
          })
        })
        .catch(() => {})
    },
    setPerPage(val, val2) {
      //改变每页条数
      this.options = {
        cpage: 1,
        selectlist: [10, 20, 50, 100, 200],
        pagesize: val,
        totalcount: this.list.length, //总条数
        totalpage: Math.ceil(this.list.length / val),
      }
      let firstIndex =
        this.options.cpage * this.options.pagesize - this.options.pagesize
      this.desserts = this.list
        .slice(firstIndex)
        .slice(0, this.options.pagesize)
    },
    turnPage(val, val2) {
      //点击页码
      this.options = {
        cpage: val,
        selectlist: [10, 20, 50, 100, 200],
        pagesize: val2.pagesize,
        totalcount: this.list.length, //总条数
        totalpage: Math.ceil(this.list.length / this.options.pagesize),
      }
      let firstIndex =
        this.options.cpage * this.options.pagesize - this.options.pagesize
      this.desserts = this.list
        .slice(firstIndex)
        .slice(0, this.options.pagesize)
    },
  },
  computed: {
    menulist() {
      return [
        {
          name: this.$t("label_To_reset_your_password"),
          show: true,
        },
      ]
    },
    headers() {
      return [
        {
          text: this.$t("label_account"),
          align: "start",
          value: "user_account",
          sortable: false,
        },
        {
          text: this.$t("label_administrator_type"),
          value: "manager_type",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("label_Associated_with_the_unit"),
          value: "org_level_uuid",
          align: "start",
          sortable: false,
        },
        {
          value: "actions",
          align: "end",
          sortable: false,
        },
      ]
    },
  },
  mounted() {
    this.options.selectlist = [5, 10, 20, 50]
    this.options.pagesize = 5
    this.options.cpage = 1
    this.options.totalcount = this.list.length //总条数
    this.options.totalpage = Math.ceil(this.list.length / this.options.pagesize) //总页数
    this.turnPage(1, this.options)
  },
  watch: {},
}
</script>
<style scoped>
.tableBoxComponent
  /deep/
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  padding: 8px 16px;
}
</style>
